import * as HttpApi from "../Api";
import * as ActionTypes from "../actionTypes";
import * as Const from '../const';

export const getSession = () => {
    return (dispatch) => {
        let accessToken = null;
        try {
            accessToken = window.localStorage.getItem(Const.TOKEN.user);
        } catch (storageError) {
            accessToken = null;
        }

        // The consumer authentication flow supports guests. Avoid calling the
        // protected session endpoint when there is no user token.
        if (!accessToken) return Promise.resolve(null);

        return HttpApi.get('eSESSION')
            .then((response) => {
                if (response.data.error) return new Error(response.data.error);
                const loginData = response.data.loginData;

                const dispatchData = {
                    type: ActionTypes.eSESSION,
                }
                const session = {};
                console.log(Const.NB_LOGIN_TYPE)
                session[Const.NB_LOGIN_TYPE[loginData.EUserRole]] = loginData;
                dispatchData['eSESSION'] = session;

                dispatch(dispatchData);

                return Promise.resolve(loginData);
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    }
};

export const setSession = (params) => {
    return (dispatch) => {
        dispatch({ type: ActionTypes.eSESSION, eSESSION: params });
        return true;
    }
}

// 국가 지정
export const setCountryCode = (params) => {
    return (dispatch) => {
        dispatch({ type: ActionTypes.COUNTRY_CODE, COUNTRY_CODE: params });
        return true;
    }
}

// uuid 지정
export const setUUID = (params) => {
    return (dispatch) => {
        dispatch({ type: ActionTypes.UUID, UUID: params });
        return true;
    }
}


// 관리자 전용 ::: 관리자 타입 지정
export const setAdminType = (params) => {
    return (dispatch) => {
        dispatch({ type: ActionTypes.ADMIN_TYPE, ADMIN_TYPE: params });
        return true;
    }
}
